//eslint-disable-next-line
import { mount } from "globalNavigationReact/index";
import React, { useEffect } from "react";
import { getPageLocale, convertLocaleFormat } from "@monorepo/utils/locales";

export const Footer = () => {
    useEffect(() => {
        mount({
            headerElemID: "privacy-footer-container",
            footerElemID: "privacy-footer-container",
            showHeader: false,
            showFooter: true,
            footerConfig: {
                showLegalFooter: true,
                showPageFooter: false,
            },
            mountLocale: convertLocaleFormat(getPageLocale(), "xx_XX"),
            mountBrand: "account",
            injectAEMfont: false,
        });
    }, []);

    return <div id="privacy-footer-container"></div>;
};
